<tabs (tabClicked)="onTabClicked($event)">
    <tab title="Awaiting Scan">
        <ag-grid-angular class="data-grid " [gridOptions]="awaitingScanGridOptions" [rowData]="awaitingScanData | async" [attr.aria-label]="widgetTitle + ' - Awaiting Scan'"></ag-grid-angular>
    </tab>
    <tab title="Awaiting Confirmation">
        <ag-grid-angular class="data-grid " [gridOptions]="awaitingConfirmationGridOptions" [rowData]="awaitingConfirmationData | async" [attr.aria-label]="widgetTitle + ' - Awaiting Confirmation'"></ag-grid-angular>
    </tab>
    <tab title="Awaiting Legal Review">
        <ag-grid-angular class="data-grid " [gridOptions]="awaitingLegalGridOptions" [rowData]="awaitingLegalData | async" [attr.aria-label]="widgetTitle + ' - Awaiting Legal Review'"></ag-grid-angular>
    </tab>
</tabs>

